export default function ({state, commit, dispatch}, value) {
    axios({
        url: '/tourclient/legend/getDefaultLegend',
        method: 'POST',
        data: 'request=' + JSON.stringify({
            ScreenName: state.data.ScreenName
        }),
    }).then(({data}) => {
        commit('data', data);
        commit('set', {rebind: false});
        setTimeout(() => {
            commit('set', {rebind: true});
        });
    }).catch(e => {
        dispatch('error', e, {root: true});
    });
}